import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ConfigurationService } from './common/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerProspectService {

  constructor(private http : HttpClient, private config: ConfigurationService) { }
  private baseUrl: string;
  Url :string; 

  savenewProspect(model : any)
  {  
 
    this.baseUrl=this.config.baseHttpURL;

  this.Url =this.baseUrl + '/api/prospects/';  
  

    return this.http.post<any>(this.Url,model);  
}  

}
